(() => {
  // Accepts "yourstore.com", "https://...", "instagram.com/name", "@name"
  const looksLikeLink = (value) =>
    /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(\/\S*)?$/i.test(value) || /^@[\w.]{2,}$/.test(value);

  const looksLikeEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);

  // Forms set up by this script, with their validate function
  const validators = new WeakMap();

  // Runs before every other submit listener (window + capture phase).
  // If a field is missing, it blocks the submit completely.
  // If everything is valid, it does nothing and the form submits normally.
  window.addEventListener('submit', (event) => {
    const validate = validators.get(event.target);
    if (!validate) return;

    if (!validate()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  async function submitForm(form) {
    if (typeof form.requestSubmit === 'function') {
      // form.requestSubmit(); // fires 'submit', so validation runs
       const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
        });
    } else {
      const event = new Event('submit', { bubbles: true, cancelable: true });
      if (form.dispatchEvent(event)) HTMLFormElement.prototype.submit.call(form);
    }
  }

  function initPartnerForm(form) {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';

    const submitBtn = form.querySelector('[data-submit]');
    const guaranteeCheckbox = form.querySelector('[data-guarantee-checkbox]');
    const guaranteeValue = form.querySelector('[data-guarantee-value]');
    const fields = [...form.querySelectorAll('input[required], select[required]')];

    // ---------- Validation ----------
    function getDropdown(field) {
      return field.type === 'hidden' ? field.closest('[data-dropdown]') : null;
    }

    function validateField(field) {
      const value = field.value.trim();
      let valid = value !== '';

      if (valid && field.type === 'email') valid = looksLikeEmail(value);
      if (valid && field.dataset.validate === 'link') valid = looksLikeLink(value);

      field.setAttribute('aria-invalid', String(!valid));

      const error = document.getElementById(field.getAttribute('aria-describedby'));
      if (error) error.hidden = valid;

      // Dropdowns: mark the wrapper and button so they can be styled red
      const dropdown = getDropdown(field);
      if (dropdown) {
        dropdown.classList.toggle('is-invalid', !valid);
        dropdown.querySelector('[data-dropdown-trigger]')?.setAttribute('aria-invalid', String(!valid));
      }

      return valid;
    }

    function focusField(field) {
      const dropdown = getDropdown(field);
      const target = dropdown ? dropdown.querySelector('[data-dropdown-trigger]') : field;
      target?.focus();
    }

    function validateAll() {
      const results = fields.map(validateField);
      const firstInvalid = results.indexOf(false);
      if (firstInvalid !== -1) {
        focusField(fields[firstInvalid]);
        return false;
      }
      return true;
    }

    validators.set(form, validateAll);

    // Validate a field once the user leaves it, then live while they fix it.
    // Dropdown hidden inputs receive 'input' + 'change' from partner-dropdown.js
    fields.forEach((field) => {
      field.addEventListener('blur', () => {
        if (field.value.trim() !== '') validateField(field);
      });
      ['input', 'change'].forEach((type) => {
        field.addEventListener(type, () => {
          if (field.getAttribute('aria-invalid') === 'true') validateField(field);
        });
      });
    });

    // ---------- Checkbox ----------
    guaranteeCheckbox?.addEventListener('change', () => {
      guaranteeValue.value = guaranteeCheckbox.checked ? 'Yes' : 'No';
    });

    // ---------- <a> submit link ----------
    // A link can't submit a form by itself, so make it act like a submit button
    if (submitBtn && submitBtn.tagName === 'A') {
      submitBtn.setAttribute('role', 'button');
      if (!submitBtn.hasAttribute('tabindex')) submitBtn.tabIndex = 0;

      submitBtn.addEventListener('click', (event) => {
        event.preventDefault();
        submitForm(form);
      });

      submitBtn.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          submitForm(form);
        }
      });

      // Without a real submit button, Enter in a text field doesn't submit the form
      form.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.matches('input:not([type="checkbox"]):not([type="hidden"])')) {
          event.preventDefault();
          submitForm(form);
        }
      });
    }
  }

  const initAll = () => document.querySelectorAll('[data-partner-form]').forEach(initPartnerForm);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();